import {
  registerUserJourneyEventHandler,
  UserJourneyEvent,
} from '~/handlers/register-user-journey-event';
import { useUserJourneyStore } from '~/stores/apostatudo/user-journey';
import type { AppsflyerConversionData } from '~/stores/apostatudo/user-journey';

export function handleAppsflyerConversionData(
  payload: AppsflyerConversionData,
): void {
  const store = useUserJourneyStore();

  store.setAppsflyerConversionData(payload);

  if (payload.is_first_launch !== true) {
    return;
  }

  registerUserJourneyEventHandler({
    event: UserJourneyEvent.APP_INSTALL,
    device: store.device.fingerprint
      ? { fingerprint: store.device.fingerprint }
      : undefined,
    appsflyer: store.appsflyer.id
      ? { id: store.appsflyer.id, platform: store.appsflyer.platform }
      : undefined,
    appsflyer_conversion: payload,
  }).catch(() => {
    // silencioso — não bloqueia o fluxo de boot do app
  });
}
